import styled from 'styled-components'

export const ContentProfile = styled.div`
  width: 100%;
  max-width: 1200px;
  position: relative;
  padding: 30px 16px 16px;

  h1.title-profile {
    font-size: 2.4rem;
    line-height: 3rem;
    color: ${({ theme }) => theme.colors.black};
  }

  .container-config-profile {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    margin-top: 50px;

    @media screen and (min-width: 750px) {
      display: grid;
      grid-template-columns: 0.75fr 1.25fr;
    }
  }

  @media screen and (min-width: 961px) {
    margin: 30px auto;
  }
`

export const FormContent = styled.div`
  .form-group {
    margin-top: 1rem;

    label {
      font-size: 1.6rem;
    }

    select {
      height: 48px;
      border: 1px solid ${({ theme }) => theme.colors.gray20};
      border-radius: ${({ theme }) => theme.radius.medium}px;
      padding: 0 16px;
      font-size: 1.4rem;
    }
  }

  h3.section-title {
    font-size: 1.6rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.black};
    margin-top: 32px;
    margin-bottom: 8px;

    &:first-child {
      margin-top: 0;
    }
  }

  h4.section-subtitle {
    font-size: 1.4rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.gray50};
    margin-top: 16px;
    margin-bottom: 4px;
  }

  .address-block {
    margin-bottom: 16px;
  }

  .field-label {
    display: block;
    font-size: 1.2rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.gray50};
    margin-bottom: 4px;
  }

  .field-error {
    display: block;
    font-size: 1.2rem;
    color: var(--color-error);
    margin: 4px 0 0;
  }

  .content-input #input-container {
    box-sizing: border-box;
  }

  .content-inputs {
    display: flex;
    flex-direction: column;

    .content-input {
      padding: 2px 0;
      margin-right: 10px;

      @media screen and (min-width: 750px) {
        margin-right: 0;
        width: 100%;
      }
    }

    /* Cada variante define seu próprio grid-template-columns diretamente,
       sem depender de um valor base sobrescrito por especificidade — evita
       que uma variante "vaze" o template de outra. */
    &.two-columns {
      @media screen and (min-width: 750px) {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 16px;
      }
    }

    &.three-columns {
      @media screen and (min-width: 750px) {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 16px;
      }
    }

    &.address-columns {
      @media screen and (min-width: 750px) {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr;
        column-gap: 16px;
      }
    }
  }

  .area-button {
    width: 100%;
    max-width: 150px;
    margin-top: 30px;
  }
`

export const PhotoProfile = styled.div`
  padding: 24px 20px;
  margin-bottom: 2rem;
  background: ${({ theme }) => theme.colors.gray10 || '#f3f4f6'};
  border: 1px solid ${({ theme }) => theme.colors.gray20 || '#e5e7eb'};
  border-radius: 8px;

  #input-container:not(:has(input:disabled)),
  #select-container,
  textarea {
    background-color: ${({ theme }) => theme.colors.white || '#fff'} !important;
  }

  .photo-section {
    margin-bottom: 40px;
  }

  .bio-section {
    margin-top: 40px;
  }

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    h3 {
      font-size: 1.6rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.black};
      margin: 0;
    }
  }

  .content-photo {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    cursor: pointer;

    .photo-content-wrapper {
      position: relative;
      width: 140px;
      height: 140px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 1px solid ${({ theme }) => theme.colors.gray10};
        object-fit: cover;
        cursor: pointer;
        pointer-events: auto; // Garante que a imagem recebe eventos de clique
      }

      .edit-photo-button {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.gray50 || '#6b7280'};
        border: 2px solid #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.2s;

        &:hover {
          background-color: ${({ theme }) => theme.colors.gray60 || '#4b5563'};
        }

        svg {
          width: 16px;
          height: 16px;
        }
      }
    }

    @media screen and (min-width: 961px) {
      justify-content: flex-start;
    }
  }

  .bio-actions {
    margin-top: 16px;
    display: flex;
    justify-content: flex-start;
  }

  .password-section {
    margin-top: 40px;
    padding-top: 24px;
    border-top: 1px solid ${({ theme }) => theme.colors.gray20 || '#e5e7eb'};

    h4 {
      font-size: 1.4rem;
      font-weight: 400;
      color: #667085;
      margin: 0 0 8px;
    }
  }

  .password-hint {
    font-size: 1.3rem;
    color: ${({ theme }) => theme.colors.gray50 || '#667085'};
    margin-bottom: 16px;
  }

  .content-input {
    margin-bottom: 16px;
  }

  .new-password-demands {
    margin-top: 8px;
    margin-bottom: 16px;

    p {
      margin-top: 16px;
    }

    ul {
      margin-top: 8px;
      list-style: none;

      li {
        padding-left: 8px;
      }
    }
  }

  .password-input-wrapper {
    position: relative;
  }

  .button-show-password {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    border: none;
    background: transparent;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 20px;
      height: 20px;
      color: ${({ theme }) => theme.colors.gray50};
    }
  }

  .password-actions {
    margin-top: 8px;
    display: flex;
    justify-content: flex-start;
  }

  @media screen and (min-width: 961px) {
    margin-bottom: 0;
    margin-left: 30px;
  }
`

export const PhotoModalRoot = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`

export const PhotoModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 0;
`

export const PhotoEditModal = styled.div`
  z-index: 1;
  position: relative;
  background: ${({ theme }) => theme.colors.white || '#fff'};
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  max-width: 100%;
  width: min(100%, 400px);
  padding: 24px 20px 20px;
  margin: 16px;
  outline: none;

  .section-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;

    h3 {
      font-size: 1.6rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.black};
      margin: 0;
    }
  }

  .ai-photo-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .modal-circle-wrap {
    width: 200px;
    height: 200px;
    margin: 0 auto 20px;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.colors.gray20 || '#e5e7eb'};
    background: ${({ theme }) => theme.colors.gray10 || '#f3f4f6'};
  }

  .modal-circle-wrap img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  .ai-photo-button {
    width: 100%;
    justify-content: center;
    margin-bottom: 20px;
  }

  .section-info {
    margin-bottom: 20px;
    font-size: 1.4rem;
    text-align: center;
    color: ${({ theme }) => theme.colors.gray50};
    background-color: #fef3e5;
    padding: 16px;
    border-radius: 8px;

    h5 {
      margin: 0;
      color: ${({ theme }) => theme.colors.warning};
    }
  }

  .modal-button-row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 8px;
    width: 100%;
  }

  .modal-button-row button {
    flex: 1;
    min-width: 0;
    width: 100%;
  }

  @media screen and (max-width: 400px) {
    .modal-button-row {
      flex-direction: column;
    }

    .modal-button-row button {
      flex: none;
      width: 100%;
    }
  }
`

export const AISuggestionsButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.colors.gray10 || '#f3f4f6'};
  border: 1px solid ${({ theme }) => theme.colors.gray20 || '#e5e7eb'};
  border-radius: 8px;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.gray70 || '#374151'};
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.gray20 || '#e5e7eb'};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  img {
    width: 16px;
    height: 16px;
  }
`

export const BioTextArea = styled.div`
  width: 100%;

  textarea {
    width: 100%;
    min-height: 100px;
    padding: 16px;
    border: 1px solid ${({ theme }) => theme.colors.gray20 || '#e5e7eb'};
    border-radius: 8px;
    font-size: 1.4rem;
    font-family: inherit;
    resize: vertical;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
      border-color: ${({ theme }) => theme.colors.primary || '#007bff'};
    }

    &::placeholder {
      color: ${({ theme }) => theme.colors.gray40 || '#9ca3af'};
    }
  }
`

export const ProfessionalInfoContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 16px;
  width: 100%;

  @media screen and (max-width: 750px) {
    flex-direction: column;
    align-items: stretch;

    button {
      width: 100%;
    }
  }
`

export const ProfessionalInfoWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;

  h4 {
    font-size: 1.4rem;
    font-weight: 400;
    color: #667085;
    margin: 0;
  }

  #input-container {
    flex: 1;
    margin: 0;
    height: auto;
    min-height: 36px;
  }

  #input-container input {
    height: 36px;
    padding: 8px 0px;
  }

  @media screen and (max-width: 750px) {
    width: 100%;

    #input-container {
      width: 100%;
      flex: none;
    }
  }
`
